// extracted by mini-css-extract-plugin
module.exports =  {"legacyScroll":"UoWH04XuvSihUKogrk6Z","root":"ZwAlLuA9atOMm1k9jVvW"};